export const experiences = [
    {
        title: "AI Engineer (RAG & LLM Systems)",
        type: "Part-time",
        company: "thepost",
        location: "Cairo",
        date: "Oct 2025 – Present",
        description: "Building RAG pipelines and LLM-based systems for content intelligence and automated workflows."
    },
    {
        title: "AI Engineer",
        type: "Full-time",
        company: "Alohadot",
        location: "Cairo",
        date: "Aug 2024 – Present",
        description: "Designing and deploying production AI systems across computer vision, NLP, and LLM applications. End-to-end ML pipelines with real-time inference."
    },
    {
        title: "Software Engineer",
        type: "Freelance",
        company: "Freelance",
        location: "Remote",
        date: "Dec 2022 – Present",
        description: "Full-stack development and AI consulting. Built custom solutions using FastAPI, Django, React, and various ML frameworks."
    }
];

export const publications = [
    {
        title: "A Unified Deep Learning Framework for Robust Multi-Class Tumor Classification in Skin and Brain MRI",
        journal: "MDPI",
        date: "August 2025",
        description: "Research on a unified deep learning approach for multi-class tumor classification across skin lesion images and brain MRI scans.",
        url: "#" // Placeholder, update if actual URL is available
    }
];

export const education = [
    {
        degree: "Bachelor of Science in Computer Science",
        school: "Cairo Higher Institute",
        year: "2024" // Added estimated year, update if known
    }
];
